import * as React from "react";
import { ActionIcon } from "@mantine/core";
import { ChevronLeft } from "lucide-react";

interface PageActionsProps {
    title?: string;
    onBack?: () => void;
    children?: React.ReactNode;
}

export function PageActions({
    title,
    onBack,
    children
}: PageActionsProps) {
    return (
        <div className="flex items-center justify-between gap-2 overflow-hidden w-full">
            <div className="flex items-center gap-1 min-w-0">
                {title && (
                    <>
                        {onBack && (
                            <ActionIcon
                                variant="subtle"
                                color="gray"
                                onClick={onBack}
                                size="lg"
                            >
                                <ChevronLeft size={20} />
                            </ActionIcon>
                        )}
                        <h2 className="text-lg sm:text-xl font-semibold truncate m-0">
                            {title}
                        </h2>
                    </>
                )}
            </div>

            <div className="flex items-center justify-end gap-2 shrink-0">
                {children}
            </div>
        </div>
    );
}
